import React from "react";

export default class ComponentToPrint extends React.Component {
    render() {

        const data = this.props.data;
        const searchData = this.props.searchData;

        return (
            <div>
                <h3><center><u>Contractor Details</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.estate}</div>
                </div>
                <table id="totalCropPdf">
                    <thead>
                        <tr>
                            <th style={{ fontWeight: "bold" }} rowSpan="2">Contractor Code</th>
                            <th style={{ fontWeight: "bold" }} rowSpan="2">Contractor Name</th>
                            <th style={{ fontWeight: "bold" }} rowSpan="2">Card Number</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, index) => (
                            <>
                                <tr>
                                    <td>{row.employeeCode}</td>
                                    <td>{row.firstName}</td>
                                    <td>{row.cardNumber}</td>
                                </tr>
                            </>
                        ))}
                    </tbody>
                </table>
                <hr />
            </div>
        );
    }
}